import React from "react";
import styled from "styled-components";

const Booking = () => {
  return <Container>My Bookings</Container>;
};

export default Booking;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background-color: #f0f2f5;
`;
